/* This file is autogenerated, see readme.md for instructions */
import ChevronUpFillSvgIcon from '@bloomreach/banana-theme/icons/chevron-up-fill.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ChevronUpFillIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ChevronUpFillSvgIcon />
    </Icon>
  );
});

ChevronUpFillIcon.displayName = 'ChevronUpFillIcon';

export default ChevronUpFillIcon;
